import { useQuery } from '@tanstack/react-query'
import type { PublicFormResponse } from '@guilleumes/types'
import api from '@/services/api'

/**
 * `GET /formulari/:token`. El tipus de la resposta és el contracte compartit amb el backend
 * (`PublicFormResponse`, a `packages/types/src/public-form.ts`), que `FormsService.getFormulariPublic`
 * declara de retorn: aquí no se'n copia res.
 */
export function useFormulariPublic(token: string | undefined) {
    return useQuery({
        queryKey: ['formulari-public', token],
        queryFn: async () => {
            if (!token) throw new Error('Token is required')
            const response = await api.get<PublicFormResponse>(`/formulari/${token}`)
            return response.data
        },
        enabled: !!token,
        staleTime: 1000 * 60 * 30, // 30 minutes
        retry: 1,
    })
}
